module.exports = __webpack_public_path__ + "img/179974.b28729f6.png";